<div class="container-fluid mt-5">
  <!-- <tabset>
    <ng-container *ngFor="let simulation of simulations; let i = index">
      <tab [active]="simulation.id == activeTabId" (selectTab)="activeTabId=simulation.id">
        <ng-template tabHeading>
          <div class="d-flex py-2 px-3" style="margin: -.5rem -1rem" [tooltip]="simulation.name">
            {{setTabName(simulation.name)}}
            <div (click)="removeTab($event)" id="{{simulation.id}}" class="ml-2">
              X
            </div>
          </div>
        </ng-template>
        <app-simulation-tab [(simulationTab)]="simulations[i]" *ngIf="simulation.id == activeTabId"></app-simulation-tab>
      </tab>
      <tab *ngIf="i === simulations.length-1" [disabled]="this.simulations.length > 4">
        <ng-template tabHeading>
          <div (click)="addNewTab($event)" class="d-flex py-2 px-3" style="margin: -.5rem -1rem">
            + Add Simulation Tab
          </div>
        </ng-template>
      </tab>
    </ng-container>
  </tabset> -->

  <div class="card">
    <div class="card-header d-flex justify-content-between">
      <ul class="nav nav-tabs card-header-tabs">

        <ng-container *ngFor="let simulation of simulations; let i = index">
          <li class="nav-item">
            <div class="nav-link d-flex" [ngClass]="{'active': simulation.id == activeTabId}" (click)="activeTabId=simulation.id" [tooltip]="simulation.name">
              {{setTabName(simulation.name)}}
              <div class="tab-icon ml-3">
                <mat-icon (click)="$event.stopPropagation(); removeTab(simulation.id)" svgIcon="close-circle"></mat-icon>
              </div>
            </div>
          </li>
        </ng-container>
        <li class="nav-item">
          <a class="nav-link ml-2" [ngClass]="{'disabled': simulations.length >= 4}" [tooltip]="(simulations.length < 5)?'Add new simulation tab': 'Too many tabs. Max of 5 tabs allowed.'" (click)="addNewTab($event)">
            <mat-icon svgIcon="plus"></mat-icon>
          </a>
        </li>
      </ul>
      <ul class="nav nav-tabs card-header-tabs">
        <li class="nav-item">
          <a class="nav-link tab-icon" tooltip="Import tabs" (click)="uploaderInput.click()">
            <mat-icon svgIcon="table-arrow-up"></mat-icon>
          </a>
        </li>
        <li class="nav-item ml-1">
          <a class="nav-link tab-icon" tooltip="Save tabs to CSV" (click)="saveTabs()">
            <mat-icon svgIcon="download-box-outline"></mat-icon>
          </a>
        </li>
      </ul>
    </div>
    <div class="card-body">
      <ng-container *ngFor="let simulation of simulations; let i = index">
        <app-simulation-tab [(simulationTab)]="simulations[i]" *ngIf="simulation.id == activeTabId"></app-simulation-tab>
      </ng-container>
    </div>
  </div>
</div>


<input hidden type="file" #uploaderInput (change)="onFileSelect($event.target)" accept=".csv" />
